import Abstract from './Abstract.es6';

export default class extends Abstract {
    constructor(Component) {
        super();
        this.Component = Component;
    }

    async badge(id, soldout = false) {
        return await App.Interface.Badge.renderHTML(soldout ? 1603 : id);
    }

    async render(product) {
        product.image   = App.Interface.Images.getFormatPath(product.imageTeaser?.path, 'screen-sm');
        product.buttons = this.Component.buttons.join();
        product.alt     = [product.name, await _('ALT.BOX.IMAGE')].join(' ');
        if (product.badgeId) product.badge = await this.badge(product.badgeId, !product.hasAvailableOffers);
        return App.Template.parse('teaser', product);
    }
}
